// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2Uh0CxwqbndIsp {\n  display: inline-block;\n}\n._1filpAoH7Juk9H {\n  padding-right: 11px;\n  font-size: 18px;\n  vertical-align: middle;\n  word-break: break-word;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  display: inline-block;\n}\n._3sYSg-uc-sUvnF {\n  flex-direction: column;\n  overflow: hidden;\n  word-break: break-word;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"smallTeamBoardsBanner": "_2Uh0CxwqbndIsp",
	"boardsPageEmoji": "_1filpAoH7Juk9H",
	"boardsMenuBanner": "_3sYSg-uc-sUvnF"
};
export default ___CSS_LOADER_EXPORT___;
